import { FormGroup, FormHelperText, styled } from '@mui/material';
import { Box, Grid } from '@customink/pigment-react';
import { KnownErrorFields } from '~/adapters/braintree/errorHandler';
import { HostedFieldKeys } from '~/adapters/braintree/constants';
import { FormLabel } from '../../components/FormLabel';
import { BraintreeToId, BraintreeToLabel } from './HostedFieldsContext';

const StyledHostedField = styled(Box)<{ error: boolean }>(({ theme, error }) => ({
    borderColor: error ? theme.palette.error.main : theme.palette.text.disabled,
    borderWidth: 1,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    height: '40px',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: theme.shape.borderRadius,
    ':hover': {
        borderColor: error ? theme.palette.error.main : theme.palette.text.primary,
    },
    '&.braintree-hosted-fields-focused': {
        borderColor: error ? theme.palette.error.main : theme.palette.secondary.main,
        borderWidth: 2,
    },
}));

interface HostedFieldsProps {
    errorFields: KnownErrorFields;
}

export function HostedFields({ errorFields }: HostedFieldsProps) {
    return (
        <Grid container spacing={3}>
            {HostedFieldKeys.map((key) => {
                const hasError = errorFields.has(key);
                return (
                    <Grid item sm={12} lg={6} key={key}>
                        <FormGroup>
                            <FormLabel error={hasError}>{BraintreeToLabel[key]}</FormLabel>
                            <StyledHostedField id={BraintreeToId[key]} error={hasError} />
                            {hasError && <FormHelperText error={hasError}>Field is empty or invalid</FormHelperText>}
                        </FormGroup>
                    </Grid>
                );
            })}
        </Grid>
    );
}
